import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Modal } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiFillEye } from "react-icons/ai";
import { descargarDocumento } from "./seguridad/DescargarDocumento";

// eslint-disable-next-line react/prop-types
function VerAnexos({ id }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const postData = (e) => {
    e.preventDefault();
    window.location.href = "/AnexoJuridica/" + id;
  };

  // 🎨 Estilo del modal
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "900px",
    height: "70vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflowY: "auto",
  };

  // 📊 Columnas
  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Usuario", accessor: "usuario" },
    { Header: "Nombre del Archivo", accessor: "nombre" },
    {
      Header: "Fecha de Carga",
      accessor: "fechaCarga",
    },
    {
      Header: "Acción",
      accessor: "url",
      Cell: ({ row }) => (
        <button
          onClick={() => descargarDocumento(row.original.url)}
          style={{
            background: "none",
            border: "none",
            color: "#1890ff",
            cursor: "pointer",
          }}
        >
          Ver Archivo
        </button>
      ),
    },
  ];

  // 📡 Consumo API
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/ObtenerAnexosJuridica/${id}`
        );

        const data = response.data.map((item) => {
          const fechaOriginal = new Date(item.fechaCarga);

          const fechaFormateada = fechaOriginal.toLocaleString("es-CO", {
            timeZone: "America/Bogota",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          });

          return {
            id: item.id,
            solicitudJuridicaId: item.solicitudJuridicaId,
            nombre: item.nombre.replace(/^1\/1\/0001(?:12:00:00AM)?/, ""),
            url: item.url,
            usuario: item.usuario,
            fechaCarga: fechaFormateada,
            fechaCargaRaw: fechaOriginal,
          };
        });

        // 🔽 Ordenar por fecha (más reciente primero)
        const dataOrdenada = data.sort((a, b) => b.fechaCargaRaw - a.fechaCargaRaw);

        setRows(dataOrdenada);
      } catch (error) {
        console.error("Error al obtener anexos:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <>
      {/* 🔘 Botón abrir modal */}
      <OverlayTrigger placement="top" overlay={<Tooltip>Ver Anexos</Tooltip>}>
        <Button variant="contained" color="secondary" onClick={handleOpen}>
          <AiFillEye style={{ color: "white", fontSize: "1.2rem" }} />
        </Button>
      </OverlayTrigger>

      {/* 📦 Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />

          {/* 🔘 Botones */}
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
              onClick={handleClose}
              variant="contained"
              color="light"
              style={{ marginLeft: 10, border: "2px solid blue", color: "blue" }}
            >
              <span style={{ color: "blue" }}>Cerrar</span>
            </Button>
          </Box>

          {!window.location.href.includes("Historial") && (
            <Button
              onClick={postData}
              variant="contained"
              color="light"
              style={{ marginLeft: 10, border: "2px solid blue", color: "blue" }}
            >
              <span style={{ color: "blue" }}>Agregar Anexo Adicional</span>
            </Button>
          )}
        </Box>
      </Modal>
    </>
  );
}

export default VerAnexos;
